module.exports = __webpack_public_path__ + "img/icon-instagram.8e193b80.svg";